import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { glossary } from 'src/app/core/translations/glossary';
import { environment } from 'src/environments/environment';

export interface SggsTableElement {
  word: string;
  definition: string;
}

const ELEMENT_DATA: SggsTableElement[] = [];

@Component({
  selector: 'app-glossary',
  templateUrl: './glossary.component.html',
  styleUrls: ['./glossary.component.scss'],
})
export class GlossaryComponent implements OnInit {
  isHandsetPortrait: boolean = false;
  bannerImage: any ='';
  bannerClass: any ='';

  columns: any = [];
  dataSource = ELEMENT_DATA;
  displayedColumns: any = null;
  currentLanguage: string = '';
  languageTranslations: any = glossary;
  activeLanguageTranslations: any = {};
  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
  
    this.bannerClass = environment.pageClass;
    this.bannerImage = environment.staticPageBanner;
// console.log('bannerImage');
    if (this.route.snapshot.paramMap.get('language')) {
      let language: string | null =
        this.route.snapshot.paramMap.get('language');

      if (language) {
        this.activeLanguageTranslations = this.languageTranslations[language];
      }

      this.columns = [
        {
          columnDef: 'word',
          header: this.activeLanguageTranslations?.wordLabel,
          cell: (element: SggsTableElement) => `${element.word}`,
        },
        {
          columnDef: 'definition',
          header: this.activeLanguageTranslations?.definitionLabel,
          cell: (element: SggsTableElement) => `${element.definition}`,
        },
      ];
      this.displayedColumns = this.columns.map((c: any) => c.columnDef);

      this.dataSource = [
        {
          word: this.activeLanguageTranslations?.commentaryLabel,
          definition: this.activeLanguageTranslations?.commentaryDetail,
        },
        {
          word: this.activeLanguageTranslations?.etymologyLabel,
          definition: this.activeLanguageTranslations?.etymologyDetail,
        },
        {
          word: this.activeLanguageTranslations?.footnotesLabel,
          definition: this.activeLanguageTranslations?.footnotesLabel,
        },
        {
          word: this.activeLanguageTranslations?.grammarLabel,
          definition: this.activeLanguageTranslations?.grammarDetail,
        },
        {
          word: this.activeLanguageTranslations?.interpretiveLabel,
          definition: this.activeLanguageTranslations?.interpretiveDetail,
        },
        {
          word: this.activeLanguageTranslations?.introductionLabel,
          definition: this.activeLanguageTranslations?.introductionDetail,
        },
        {
          word: this.activeLanguageTranslations?.literalLabel,
          definition: this.activeLanguageTranslations?.literalDetail,
        },
        {
          word: this.activeLanguageTranslations?.meaningLabel,
          definition: this.activeLanguageTranslations?.meaningDetail,
        },
        {
          word: this.activeLanguageTranslations?.noteLabel,
          definition: this.activeLanguageTranslations?.noteDetail,
        },
        {
          word: this.activeLanguageTranslations?.poeticLabel,
          definition: this.activeLanguageTranslations?.poeticLabel,
        },
      ];
    }
  }

  isHandsetPortraitStatus(status: boolean): void {
    this.isHandsetPortrait = status;
  }
}
